"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleField = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var TitleField = function (_a) {
    var titleData = _a.titleData;
    return (react_2.default.createElement(react_1.Box, { width: "100%", css: titleData.style, className: "" + (titleData.class ? titleData.class : "") },
        titleData.data.title && (react_2.default.createElement(react_1.Text, { fontWeight: "bold", fontSize: "1em" }, titleData.data.title)),
        titleData.data.caption && (react_2.default.createElement(react_1.Text, { fontSize: "0.75em" }, titleData.data.caption))));
};
exports.TitleField = TitleField;
